
import React from 'react';
import { NavBar } from '@/components/navbar';
import PortfolioHeader from '@/components/portfolio/settings/PortfolioHeader';

interface PortfolioNavigationProps {
  portfolioId: string;
  selectedPortfolio: string;
  portfolioOptions: Array<{id: string; title: string; role: string | null}>;
  handlePortfolioChange: (value: string) => void;
  handleBack: () => void;
}

const PortfolioNavigation = ({
  portfolioId,
  selectedPortfolio,
  portfolioOptions,
  handlePortfolioChange,
  handleBack
}: PortfolioNavigationProps) => {
  return (
    <div className="sticky top-0 z-50 bg-white shadow-sm">
      <NavBar 
        portfolioDropdown={true}
        selectedPortfolio={selectedPortfolio || portfolioId || ''}
        portfolioOptions={portfolioOptions}
        onPortfolioChange={handlePortfolioChange}
      />
      
      <div className="w-full bg-brand-light">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8 w-full">
          <PortfolioHeader handleBack={handleBack} />
        </div>
      </div>
    </div>
  );
};

export default PortfolioNavigation;
